'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('add-journal-entry', {
      url: '/accounting/journal/add',
      template: '<add-journal-entry></add-journal-entry>'
    });
}



// WEBPACK FOOTER //
// ./client/app/accounting/add-journal-entry/add-journal-entry.routes.js